// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAHheGEL9nN9XSzJiruXD7IUklUrnj-XcQ',
  authDomain: 'twitter-clone-7e.firebaseapp.com',
  projectId: 'twitter-clone-7e',
  storageBucket: 'twitter-clone-7e.firebasestorage.app',
  messagingSenderId: '370952078553',
  appId: '1:370952078553:web:86e19c22c7dc0b0ae3eac8',
  measurementId: 'G-RLKE7Y5NJB',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore();
